import React, { FunctionComponent, useState } from 'react';
import { TabContext, TabPanel } from '@mui/lab';
import {
  Card,
  CardContent,
  Container,
  SxProps,
  useMediaQuery,
  useTheme,
} from '@mui/material';

import Breadcrumbs, {
  BreadcrumbOption,
} from '../../../../components/BreadCrumb/Breadcrumbs';
import TabBar, {
  defaultTabRootStyles,
  ITabItem,
} from '../../../../components/V2/Tabs/type1/TabBar';
import NewRequestsTab from './Tabs/NewRequestsTab';
import ResolvedRequestsTab from './Tabs/ResolvedRequestsTab';

export type TState = {
  selectedTab: ITabItem;
};

const tableCardContainerStyles: SxProps = {
  borderRadius: '20px',
  boxShadow: '0px 14px 40px 0px #6E9DB22E',
};

const tabs: ITabItem[] = [
  {
    index: 0,
    key: 'newRequests',
    title: 'New Requests',
  },
  {
    index: 1,
    key: 'resolveRequests',
    title: 'Resolved Requests',
  },
];

const initialState: TState = {
  selectedTab: tabs[0],
};

const AdminRescheduleRequestsPage: FunctionComponent = () => {
  const theme = useTheme();
  const isXsScreen = useMediaQuery(theme.breakpoints.only('xs'));

  // State
  const [state, setState] = useState({ ...initialState });

  const updateStateAttributes = (attributes: Partial<TState>) => {
    setState((prevState) => ({
      ...prevState,
      ...attributes,
    }));
  };

  const renderTabPanel = () => {
    let tabPanel: JSX.Element | null = null;

    const panelProps = {
      value: state.selectedTab.index.toString(),
      sx: { p: 0 },
    };

    switch (state.selectedTab.index) {
      case 0:
        tabPanel = (
          <TabPanel {...panelProps}>
            <NewRequestsTab />
          </TabPanel>
        );
        break;

      case 1:
        tabPanel = (
          <TabPanel {...panelProps}>
            <ResolvedRequestsTab />
          </TabPanel>
        );
        break;

      default:
        tabPanel = null;
        break;
    }

    return tabPanel;
  };

  const constructBreadcrumbOptions = () => {
    const options: Array<BreadcrumbOption> = [
      {
        type: 'link',
        title: 'Home',
        link: `${process.env.PUBLIC_URL}`,
      },
      {
        type: 'text',
        title: 'Reschedule Requests',
        highlight: true,
      },
    ];

    return options;
  };

  const breadcrumbOptions = constructBreadcrumbOptions();

  return (
    <Container maxWidth="xl">
      <div style={{ padding: '30px 0' }}>
        <Breadcrumbs
          options={breadcrumbOptions}
          textColor="#647488"
          showDropDown={isXsScreen}
        />
      </div>
      <div>
        <Card sx={tableCardContainerStyles}>
          <CardContent sx={{ p: 0 }}>
            <TabContext value={state.selectedTab.index.toString()}>
              <div style={{ padding: '20px' }}>
                <div>
                  <TabBar
                    selectedTab={state.selectedTab}
                    tabs={tabs}
                    tabsProps={{
                      sx: { width: { xs: 'auto', sm: 'fit-content' } },
                    }}
                    tabProps={{
                      sx: {
                        '&.MuiButtonBase-root': {
                          ...defaultTabRootStyles,
                          p: { xs: 'auto', sm: '10px 55px' },
                        },
                      },
                    }}
                    onChange={(e, value) =>
                      updateStateAttributes({ selectedTab: tabs[value] })
                    }
                  />
                </div>
              </div>
              <div>{renderTabPanel()}</div>
            </TabContext>
          </CardContent>
        </Card>
      </div>
    </Container>
  );
};

export default AdminRescheduleRequestsPage;
